import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import LoaderScreen from '../../../component/loader/loaderScreen';
import moment from 'moment';
import { GetSingleBlogger } from '../../../redux/admin/bloggers/bloggersServicesSync';
import HTMLReactParser from 'html-react-parser';

const BlogAdminDetails = () => {
  const { blogId } = useParams();

  const dispatch = useDispatch();

  const { singleStoryPageLoader, singleStoryPageDetails } = useSelector(
    (state) => state.blogger
  );

  useEffect(() => {
    dispatch(GetSingleBlogger({ Id: blogId }));
  }, [blogId]);

  console.log(singleStoryPageDetails, 'vision control');

  return (
    <>
      {singleStoryPageLoader && <LoaderScreen />}

      {!singleStoryPageLoader && (
        <div class="row">
          <div class="col-xl-9 col-lg-8">
            <div class="row">
              <div class="col-lg-12">
                <div class="card">
                  <div class="card-body">
                    <div class="flex flex-col gap-2">
                      <div>
                        <p class="mb-0">
                          {moment(singleStoryPageDetails.date).format(
                            'MMM, DD YYYY hh:mm:ss A'
                          )}
                        </p>
                      </div>
                      <div>
                        <div className="w-full max-h-[54.75rem] overflow-hidden rounded-2xl">
                          <img
                            src={singleStoryPageDetails?.cover_pic || ''}
                            className="w-full h-auto object-contain"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="mt-4">
                      <h4
                        class="fw-medium text-dark capitalize font-bold text-4xl"
                        style={{ fontWeight: '700' }}
                      >
                        {singleStoryPageDetails?.title}
                      </h4>

                      <p class="mb-0 mt-2 w-full">
                        {HTMLReactParser(
                          singleStoryPageDetails?.article?.toString() || ''
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BlogAdminDetails;
